import { Control, Controller, FieldValues, RegisterOptions, useFormContext } from "@graphcommerce/ecommerce-ui";
import { ClassAttributes, SelectHTMLAttributes } from "react";
type SelectFieldElementProps = {
  name?: string
  label?: string
  fullwidth?: boolean
} & ClassAttributes<HTMLSelectElement> & SelectHTMLAttributes<HTMLSelectElement>
export default function SelectField({ name, required, label, children, fullwidth, ...props }: SelectFieldElementProps) {
  return (
    <div>
      <div className="flex gap-2 items-center">
        {label && <label className="ml-3">{label} {required && <span className="text-error-500">{'*'}</span>}</label>}
        <select {...props} className={`text-sm py-1 px-3 border border-solid border-light-170 rounded-sm outline-0 shadow-none ${fullwidth && 'w-full'}`}>
          {!props.defaultValue ? <option value={''}>انتخاب کنید...</option> : null}
          {children}
        </select>
      </div>
    </div>
  )
}